/**
 * useShotChart — modal state for the shot chart overlay.
 *
 * Extracted from EstadisticasNew.js (shotChartOpen, shotChartAction, the
 * setShotChartOpen / setShotChartAction calls inside recordAction and
 * handleShotChartRecorded).
 *
 * The actual shot persistence (court x/y → gameShotChartData) lives in
 * useStatsSession.recordShotChart. This hook only owns the dialog visibility
 * and the "what action triggered the chart" context.
 */

import { useState, useCallback } from 'react';

export function useShotChart() {
  const [shotChartOpen, setShotChartOpen] = useState(false);
  const [shotChartAction, setShotChartAction] = useState(null);

  /**
   * Open the shot chart for a specific action context. Pass the same payload
   * shape that recordAction emits via its onShotAction callback:
   *   { player, actionCode, made, timeSec, period }
   */
  const openForAction = useCallback((actionContext) => {
    setShotChartAction(actionContext);
    setShotChartOpen(true);
  }, []);

  const close = useCallback(() => {
    setShotChartOpen(false);
    setShotChartAction(null);
  }, []);

  const reset = useCallback(() => {
    setShotChartOpen(false);
    setShotChartAction(null);
  }, []);

  return {
    shotChartOpen,
    shotChartAction,
    openForAction,
    close,
    reset,
  };
}
